import React, { useEffect, useState } from "react";
import TableHeadOptions from "../component/TableHeadOptions";
import { useNavigate } from "react-router";
import MenuIcon from "../component/MenuIcon";
import { ax_claim_getAllClaimIssue } from "../api/claim";
import Pagination from "../component/Pagination";
import Loading from "../component/Loading";
// import Table from "../component/Table";

const ClaimList = ({
  setSelectedClaim,
  showSidebar,
  setShowSidebar,
  createdFromBrand,
  setCreatedFromBrand,
  togglePopupShow,
  handleShowAddUser,
}) => {
  const statusColors = {
    approved: "text-green-500",
    resolved: "text-green-500",
    rejected: "text-red-500",
    pending: "text-orange-500",
  };
  // eslint-disable-next-line
  const navigate = useNavigate();
  // const [isFilterExpanded, setIsFilterExpanded] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // const data = Array.from({ length: 120 }, (_, i) => ({
  //   id: i + 1,
  //   name: i % 2 === 0 ? "Kayser Dheen" : "John Carter",
  //   email: i % 3 === 0 ? "kayser.dheen@gmail.com" : "john.carter@gmail.com",
  //   phone: "9784512689",
  //   taxNo: i % 5 === 0 ? "987456321123456" : "None",
  //   frameNo: i % 3 === 0 ? "97564218" : "None",
  //   submitDate: "12/12/2024",
  //   status: i % 4 === 0 ? "Approved" : i % 3 === 0 ? "Pending" : "Rejected",
  // }));

  // const toggleFilter = () => {
  //   setIsFilterExpanded((prev) => !prev);
  // };

  // const totalPages = Math.ceil(data.length / itemsPerPage);
  // const handlePageChange = (page) => {
  //   if (page > 0 && page <= totalPages) {
  //     setCurrentPage(page);
  //   }
  // };

  const [allClaimIssues, setAllClaimIssues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const [isSortedLatest, setIsSortedLatest] = useState(false);

  // const today = new Date();
  // const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  // const formattedStartDate = startDate.toISOString().split("T")[0];

  // Get the last date of the current month (end of the month)
  // const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  // const formattedEndDate = endDate.toISOString().split("T")[0];

  const [filterDate, setFilterDate] = useState({
    startDate: "",
    endDate: "",
    // startDate: formattedStartDate,
    // endDate: formattedEndDate,
  });

  // const itemsPerPage = 6;
  //   const startIndex = (currentPage - 1) * itemsPerPage;

  //   const displayedWarranty = allWarranty.slice(
  //     startIndex,
  //     startIndex + itemsPerPage
  //   );

  // const statusColors = {
  //   approved: "text-green-400",
  //   rejected: "text-red-500",
  //   pending: "text-orange-500",
  // };
  const toggleFilter = () => {
    // setIsFilterExpanded((prev) => !prev);
    setIsLoading(true);
    setIsSortedLatest((prev) => !prev);

    setAllClaimIssues((prevClaimIssues) => {
      return [...prevClaimIssues].sort((a, b) => {
        return isSortedLatest
          ? new Date(a.createdAt) - new Date(b.createdAt) // Oldest to latest
          : new Date(b.createdAt) - new Date(a.createdAt); // Latest to oldest
      });
    });
    setIsLoading(false);
  };

  //   const totalPages = Math.ceil(allWarranty.length / itemsPerPage);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handlePageChange = (page) => {
    // console.log("page <= totalPages - ", page <= totalPages);
    // console.log("page - " + page);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const startDate = filterDate?.startDate;
    const endDate = filterDate?.endDate;

    const ax_fetchAllClaimIssues = await ax_claim_getAllClaimIssue(
      currentPage,
      searchQuery,
      itemsPerPage,
      createdFromBrand,
      startDate,
      endDate
    );

    if (!ax_fetchAllClaimIssues || !ax_fetchAllClaimIssues.success) {
      return; // Handle this case (show a message or fallback UI)
    }

    if (ax_fetchAllClaimIssues.code === 200 && ax_fetchAllClaimIssues.success) {
      // console.log(
      //   "ax_fetchAllClaimIssues - " + JSON.stringify(ax_fetchAllClaimIssues)
      // );
      //   console.log("count" + JSON.stringify(ax_fetchAllClaimIssues.data.length));

      setAllClaimIssues(ax_fetchAllClaimIssues.data);
      setTotalPages(ax_fetchAllClaimIssues.totalPages);
      setIsLoading(false);
    }
    // console.log("fetchData");
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchData();
    }, 500); // debounce delay

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [currentPage, searchQuery, createdFromBrand, filterDate]);

  //   console.log("totalPages - " + totalPages);
  //   console.log("currentPage - " + currentPage);
  //   console.log("startIndex - " + startIndex);

  const onClaimRowClick = (rowContent) => {
    navigate("/claim");
    setSelectedClaim(rowContent);
  };
  // const handleImagesChange = (images) => {
  //   if (Array.isArray(images) && images.length > 0) {
  //     return images.map((image, index) => (
  //       <img
  //         key={index}
  //         src={`data:image/jpeg;base64,${image.base64}`}
  //         alt={image.name}
  //         className="w-20 h-20 object-cover rounded-md"
  //       />
  //     ));
  //   }
  //   return <span>No Image</span>;
  // };

  return (
    <section className="xl:pl-4 w-full h-full bg-[#F3EEEE]">
      <div className="p-4 h-full bg-white rounded-lg">
        <section className="flex items-center">
          <MenuIcon
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            setCreatedFromBrand={setCreatedFromBrand}
            togglePopupShow={togglePopupShow}
            handleShowAddUser={handleShowAddUser}
          />
          <div className="flex-grow">
            <TableHeadOptions
              title={"Claim List"}
              searchQuery={searchQuery}
              handleSearchChange={handleSearchChange}
              toggleFilter={toggleFilter}
              isSortedLatest={isSortedLatest}
              filterDate={filterDate}
              setFilterDate={setFilterDate}
            />
          </div>
        </section>
        {/* <main>
          <Table
            data={allClaimIssues}
            headerFields={[
              {
                label: "S.No",
                backendField: "serialNumber",
              },
              {
                label: "Name",
                backendField: "name",
              },
              {
                label: "Nature Of Issue / Other Issue",
                backendField: "natureOfIssue",
              },
              {
                label: "Images",
                backendField: "images",
                render: (row) => renderImages(row.images),  // Use the renderImage function
              },
              {
                label: "Wow No",
                backendField: "wowNo",
              },
              {
                label: "Frame No",
                backendField: "frameNo",
              },
              {
                label: "Claim Date",
                backendField: "purchaseDate",
              },
              {
                label: "Status",
                backendField: "warrStatus",
              },
            ]}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            onRowClick={onClaimRowClick}
          />
        </main> */}
        {isLoading ? (
          <main className="h-[calc(100vh-105px)] w-full flex items-center justify-center">
            <Loading />
          </main>
        ) : (
          <main className="overflow-scroll no-scrollbar">
            {allClaimIssues?.length === 0 ? (
              <main className="h-[calc(100vh-105px)] w-full flex items-center justify-center">
                No records found!
              </main>
            ) : (
              <table className="w-full border border-gray-200 bg-white rounded-lg shadow-md overflow-hidden mt-4">
                <thead className="bg-gray-100">
                  <tr>
                    {[
                      "S.No",
                      "Name",
                      "Nature of issues/Other issues",
                      "Claim Number",
                      "Wow No",
                      "Frame No",
                      "Claim Date",
                      "Status",
                    ].map((heading, index) => (
                      <th
                        key={index}
                        className="p-3 text-left text-gray-700 font-medium text-sm border-b"
                      >
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allClaimIssues?.map((claim, index) => (
                    <tr
                      key={claim?._id}
                      className="hover:bg-gray-50 transition cursor-pointer"
                      onClick={() => onClaimRowClick(claim)}
                    >
                      <td className="p-3 border-b text-sm text-gray-600">
                        {index + 1}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {claim.warrantyFormID?.name}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {claim.otherIssue === ""
                          ? claim.natureOfIssue
                          : claim.otherIssue}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {claim?.claimNumber}
                      </td>
                      {/* <td className="p-3 border-b text-sm text-gray-600">
                        {handleImagesChange(claim.images)}
                      </td> */}
                      <td className="p-3 border-b text-sm text-gray-600">
                        {claim.wowNo}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {claim.frameNo}
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        {
                          new Date(claim.purchaseDate)
                            .toISOString()
                            .split("T")[0]
                        }
                      </td>
                      <td className="p-3 border-b text-sm text-gray-600">
                        <span
                          className={`font-semibold ${
                            statusColors[claim?.warrStatus?.toLowerCase()] ||
                            "text-orange-500"
                          }`}
                        >
                          {claim.warrStatus}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {allClaimIssues?.length === 0 ? null : (
              <Pagination
                handlePageChange={handlePageChange}
                currentPage={currentPage}
                totalPages={totalPages}
              />
            )}
          </main>
        )}
      </div>
    </section>
  );
};

export default ClaimList;
